module.exports = "precision mediump float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float radius;\nuniform float angle;\nuniform vec2 offset;\n\nvoid main(void)\n{\n   vec2 coord = vTextureCoord - offset;\n   float dist = length(coord);\n\n   float ratio = (radius - dist) / radius;\n   float angleMod = ratio * ratio * angle;\n   float s = sin(angleMod);\n   float c = cos(angleMod);\n   coord = vec2(coord.x * c - coord.y * s, coord.x * s + coord.y * c);\n   \n   gl_FragColor = texture2D(uSampler, coord+offset);\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/filters/twist.frag.glsl
 ** module id = 22
 ** module chunks = 0
 **/